import {h, Fragment} from "preact"
export default function BoxFilters({ facet, toggleProductFilter, columns }) {
    
    if(facet.name === 'Size') {
        facet.data.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
    }

    return (
        <ul 
            class="ns-filters-list ns-box-list" 
            style={`--facet-columns: ${(window.innerWidth < 768) ? columns.mobileCols : columns.desktopCols }`}
        >
            {facet.data?.map(value => {
                const fieldName = facet.field.replaceAll('.', '-').replaceAll(' ', '-').toLowerCase();
                const valueName = value.value.replaceAll(' ', '-').toLowerCase();
                return (<li
                    class="ns-filter-item"
                    data-nosto-element="facet-setting"
                >
                    <input 
                        type="checkbox"
                        class="ns-filter-input"
                        id={`${fieldName}-${valueName}`}
                        checked={value.selected} 
                        onChange={(e) => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                    <label class="ns-filter-label" for={`${fieldName}-${valueName}`}>
                        <span class="ns-filter-text">
                            {value.value}
                        </span>
                    </label>
                </li>)
            })}
        </ul>
    )
}